import { useEffect, useRef, useState } from 'react'
import { ImageSwiperHookProps, ImageSwiperViewProps } from '../types'

export const useImageSwiper = (
    props: ImageSwiperHookProps,
): ImageSwiperViewProps => {
    const { dynamicDataLoading, dynamicSiteData } = props
    const [timeLeft, setTimeLeft] = useState<number>()

    const progressCircle = useRef<SVGSVGElement>(null)
    const progressContent = useRef<HTMLSpanElement>(null)

    const onAutoplayTimeLeft = (
        // "Swiper" type is not provided by the library
        swiper: any,
        timeLeft: number,
        percentage: number,
    ) => {
        if (progressContent.current) {
            progressCircle?.current?.style.setProperty(
                '--progress',
                String(1 - percentage),
            )
            progressContent.current.textContent = `${Math.ceil(
                timeLeft / 1000,
            )}s`
        }
    }

    useEffect(() => {
        if (!dynamicDataLoading && !!dynamicSiteData?.images?.[0]?.seconds) {
            setTimeLeft(dynamicSiteData?.images?.[0]?.seconds * 1000)
        }
    }, [dynamicDataLoading, dynamicSiteData?.images])

    return {
        ...props,
        timeLeft,
        setTimeLeft,
        onAutoplayTimeLeft,
        progressCircle,
        progressContent,
    }
}
